import * as React from 'react';
import MainLayout from './common/MainLayout';
import { Switch, Route, withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import MapLayout from './map/MapLayout';
import LoginView from './login/LoginView';
import FreeUnitsView from './units/FreeUnitsView';
import UnitView from './units/UnitView';
import TruckView from './trucks/TruckView';
import FreeTrucksView from './trucks/FreeTrucksView';
import RegisterUserView from './register/RegisterUserView';
import RegisterUserForm from './register/user/RegisterUserForm';
import RegisterCompanyView from './register/company/RegisterCompanyView';
import CompaniesView from './admin/companies/CompaniesView';
import FeedbackView from './admin/FeedbackView';
import ChangePassword from './login/ChangePassword';
import PasswordChangedSuccess from './login/PasswordChangedSuccess';
import PasswordResetedSuccess from './login/PasswordResetedSuccess';
import NotFound from './common/NotFound';
import { connect } from 'react-redux';
import { ApplicationState } from './store';
import { LoginState } from './login/loginStore';
import PrivateRoute from './components/routes/PrivateRoute';
import SettingsView from './account/SettingsView';
import ForgotPassword from './login/ForgotPassword'
import { RouteName } from './routeNames';
import StatisticsView from './statistics/StatisticsView'
import HelpView from './help/HelpView'
import LandingPageView from './landingPage/LandingPageView';
import MediaPageView from './landingPage/MediaPageView';
import pdf from './register/privacy/Kayttoehdot-UnitSpotter_20180925.pdf'
import gdpr from './register/privacy/Tietosuojaseloste-UnitSpotter.pdf'

type Props = RouteComponentProps<{}>;

const Terms: React.SFC = () => {
    const dl = document.createElement('a');
    dl.setAttribute('href', encodeURIComponent(pdf));
    dl.setAttribute('download', 'terms.pdf');
    dl.click();
    return <a href={pdf} download style={{ color: 'black' }}>Avaa käyttöehdot</a>;
}

const Privacy: React.SFC = () => {
    const dl = document.createElement('a');
    dl.setAttribute('href', encodeURIComponent(gdpr));
    dl.setAttribute('download', 'terms.pdf');
    dl.click();
    return <a href={gdpr} download style={{ color: 'black' }}>Avaa tietosuojalauseke</a>;
}

class Routes extends React.Component<Props & LoginState> {
    public render() {
        const mainPageComponent = this.props.isLoggedIn ?
            MapLayout : (location.pathname === '/media' ? MediaPageView : LandingPageView);
        return (
            <MainLayout
                userLoggedIn={this.props.isLoggedIn}
                userRole={this.props.role || "noRole"}
                passwordChangeRequired={this.props.passwordChangeRequired}
                history={history}
                isLandingPage={location.pathname === '/' && !this.props.isLoggedIn}
                isMediaPage={location.pathname === '/media' && !this.props.isLoggedIn}
            >
                <Switch>
                    {location.pathname === '/' && this.props.isLoggedIn ? (
                        <Redirect to={RouteName.Map} />
                    ) : null}
                    <Route exact path={RouteName.Main} component={mainPageComponent} />
                    <Route exact path={RouteName.Media} component={mainPageComponent} />
                    <PrivateRoute exact path={RouteName.Map} component={mainPageComponent} />
                    <Route exact path={RouteName.Login} component={LoginView} />
                    <PrivateRoute exact path={RouteName.Units} component={FreeUnitsView} />
                    <PrivateRoute exact path={RouteName.Trucks} component={FreeTrucksView} />
                    <Route exact path={RouteName.RegisterUser} component={RegisterUserView} />
                    <Route exact path={RouteName.RegisterUserId} component={RegisterUserForm} />
                    <Route exact path={RouteName.RegisterCompany} component={RegisterCompanyView} />
                    {this.props.role === "Administrator" ? (
                        <PrivateRoute path={RouteName.AdminCompanies} component={CompaniesView} />
                    ) : null}
                    {this.props.role === "Administrator" ? (
                        <PrivateRoute path={RouteName.AdminFeedback} component={FeedbackView} />
                    ) : null}
                    <PrivateRoute path={RouteName.ChangePassword} component={ChangePassword} />
                    <PrivateRoute path={RouteName.ChangePasswordSuccess} component={PasswordChangedSuccess} />
                    <Route path={RouteName.PasswordResetedSuccess} component={PasswordResetedSuccess} />
                    <PrivateRoute path={RouteName.Settings} component={SettingsView} />
                    <Route exact path={RouteName.ResetPassword} component={ForgotPassword} />
                    <PrivateRoute exact path={RouteName.Statistics} component={StatisticsView} />
                    <PrivateRoute exact path={RouteName.Help} component={HelpView} />
                    <Route path="/terms" component={Terms} />
                    <Route path="/privacy" component={Privacy} />
                    <PrivateRoute exact path={RouteName.Unit} component={UnitView} />
                    <PrivateRoute exact path={RouteName.Truck} component={TruckView} />
                    <Route component={NotFound} />
                </Switch>
            </MainLayout>
        );
    }
}

export default withRouter<Props, any>(connect<any, any, any, any>((state: ApplicationState) => state.login)(Routes));


// WEBPACK FOOTER //
// ./src/Routes_fix.tsx